export class UserPermModel{
  usGroup ='';
  usAdmin = '';
  usStaff =  '';
  usOncologist = '';
  usPharma =  '';
  usAccounting = '';
  userID = '';
  modifiedDate = '2021-01-01';
  compCode = '1';
}
